import { parseISO, formatDistance } from 'date-fns';
import { useDate } from '~/hooks/use-date';

export const useDateRange = (startDate: string, endDate: string) => {
  const { formatISODate } = useDate();
  const today = new Date();
  const parsedEndDate = endDate ? parseISO(endDate) : null;
  const startDateFormatted = startDate ? formatISODate(startDate) : 'N/A';
  const endDateFormatted = endDate ? formatISODate(endDate) : 'N/A';
  const dateRangeLabel = !startDate && !endDate ? 'Not Scheduled' : `${startDateFormatted} - ${endDateFormatted}`;
  const dateDistance =
    parsedEndDate && parsedEndDate > today ? ` ( ${formatDistance(parsedEndDate, today)} remaining )` : '';
  return [dateRangeLabel, dateDistance];
};
